export enum LiveClassesStatus {
  WAITING_FOR_CLASS = 'waiting-for-next-class',
  SIGNUP_AVAILABLE = 'signup-available',
  SIGNED_UP = 'signed-up',
  CLASS_READY = 'class-ready',
  JOINED = 'joined',
  LOADING = 'loading',
}
